<template>
  <div>
    <svg
      v-if="isSmallScreen"
      class="radius-svg"
      :class="position"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.3984 20.8799V0.786621H0.193359V5.78662H4.39844C9.92188 5.78662 14.3984 10.2637 14.3984 15.7866V20.8799H19.3984Z"
        fill="currentColor"
      />
    </svg>
    <svg
      v-else
      class="radius-svg"
      :class="position"
      width="50"
      height="49"
      viewBox="0 0 50 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M49.25 0.75V48.75H29.25V36.75C29.25 27.9136 22.0859 20.75 13.25 20.75H0.5V0.75H49.25Z"
        fill="currentColor"
      />
    </svg>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isSmallScreen: false,
    };
  },
  props: {
    position: {
      type: String,
      required: true,
    },
  },
  methods: {
    updateScreenSize() {
      this.isSmallScreen = window.matchMedia("(max-width: 767px)").matches;
    },
  },
  mounted() {
    this.updateScreenSize();
    window.addEventListener("resize", this.updateScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateScreenSize);
  },
};
</script>

